import { dissolvedOxygen } from './dissolvedOxygen'
import { nitrates } from './nitrates'
import { salinity } from './salinity'
import { specificConductivity } from './specificConductivity'
import { temperature } from './temperature'
import { totalDissolvedSolids } from './totalDissolvedSolids'
import { turbidity } from './turbidity'

export const aquaTroll500 = {
  dissolvedOxygen,
  nitrates,
  salinity,
  specificConductivity,
  temperature,
  totalDissolvedSolids,
  turbidity,
}
